import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {
  ChangeInvoicesPageSizeAction,
  invoicesListActionTypes, LoadInvoicesSuccessAction, OrderInvoicesByAction,
  PageInvoicesToAction,
  QuickSearchInvoicesAction,
  SearchInvoicesAction,
  ToggleSearchInvoicesAction
} from '../actions/invoices-list';
import {DEFAULT_PAGE_SIZE} from '../consts';

export interface InvoicesState {
  // tslint:disable-next-line:no-any
  array: any[];
  showFilter: boolean;
  quickSearch: string;
  // tslint:disable-next-line:no-any
  filter: any;
  page: number;
  pageSize: number;
  orderBy: string;
  count: number;
}

const initialState: InvoicesState = {
  array: undefined,
  showFilter: false,
  quickSearch: undefined,
  filter: undefined,
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  orderBy: 'created descending',
  count: 0
};

export function InvoicesStateListReducer(state: InvoicesState = initialState, action: Action): InvoicesState {
  switch (action.type) {

    case invoicesListActionTypes.TOGGLE_SEARCH:
      return handleToggleSearchAction(state, action);
    case invoicesListActionTypes.QUICK_SEARCH:
      return handleQuickSearchAction(state, action);
    case invoicesListActionTypes.SEARCH:
      return handleSearchAction(state, action);
    case invoicesListActionTypes.PAGE_TO:
      return handlePageToAction(state, action);
    case invoicesListActionTypes.CHANGE_PAGE_SIZE:
      return handleChangePageSizeAction(state, action);
    case invoicesListActionTypes.ORDER_BY:
      return handleOrderByAction(state, action);
    case invoicesListActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case invoicesListActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case invoicesListActionTypes.CLEAR:
      return handleLoadClearActions();
    default:
      return state;
  }
}

function handleToggleSearchAction(state: InvoicesState, action: ToggleSearchInvoicesAction): InvoicesState {
  const newState: InvoicesState = {
    ... state,
    showFilter: action.payload
  };
  return newState;
}

function handleQuickSearchAction(state: InvoicesState, action: QuickSearchInvoicesAction): InvoicesState {
  const newState: InvoicesState = {
    ... state,
    quickSearch: action.payload,
    page: 1
  };
  return newState;
}

function handleSearchAction(state: InvoicesState, action: SearchInvoicesAction): InvoicesState {
  const newState: InvoicesState = {
    ... state,
    filter: action.payload,
    page: 1
  };
  return newState;
}

function handlePageToAction(state: InvoicesState, action: PageInvoicesToAction): InvoicesState {
  const newState: InvoicesState = {
    ... state,
    page: action.payload
  };
  return newState;
}

function handleLoadSuccessAction(state: InvoicesState, action: LoadInvoicesSuccessAction): InvoicesState {
  const newState: InvoicesState = {
    ... state,
    array: action.payload.array,
    count: action.payload.count
  };
  return newState;
}


function handleChangePageSizeAction(state: InvoicesState, action: ChangeInvoicesPageSizeAction): InvoicesState {
  const newState: InvoicesState = {
    ... state,
    page: 1,
    pageSize: action.payload
  };
  return newState;
}
function handleOrderByAction(state: InvoicesState, action: OrderInvoicesByAction): InvoicesState {
  const newState: InvoicesState = {
    ... state,
    orderBy: action.payload
  };
  return newState;
}

function handleLoadClearActions(): InvoicesState {
  const newState: InvoicesState = {
    array: undefined,
    showFilter: false,
    quickSearch: undefined,
    filter: undefined,
    page: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    orderBy: 'created descending',
    count: 0
  };
  return newState;
}

function handleLoadErrorActions(state: InvoicesState): InvoicesState {
  return state;
}


export const invoicesListSelectors = {
  showFilter: (state: InvoicesState) => _.get(state, 'showFilter', false),
  quickSearch: (state: InvoicesState) => _.get(state, 'quickSearch'),
  filter: (state: InvoicesState) => _.get(state, 'filter'),
  page: (state: InvoicesState) => _.get(state, 'page', 1),
  pageSize: (state: InvoicesState) => _.get(state, 'pageSize', DEFAULT_PAGE_SIZE),
  orderBy: (state: InvoicesState) => _.get(state, 'orderBy'),
  array: (state: InvoicesState) => _.get(state, 'array', []),
  count: (state: InvoicesState) => _.get(state, 'count', 0),
};
